import types from '../actions/types';

const initialState = {
};

const cleanableState = {
  legalHeir: true,
  beneficiaries: [{Document: '', FullName: '', Age: 0, Percentage: 0, ResponsiblePerson: ''}],
  selected: 'gold',
};

const apersonal = (state = {...initialState, ...cleanableState}, action) => {
  switch (action.type) {

    case types.CLEAN:
      return { ...state, ...cleanableState};
      
    case types.SET_APERSONAL_VALUE: {
      const { type, value } = action.payload;
      return {
        ...state,
        [type]: value
      }
    };

    default:
      return state;
  }
};

export default apersonal;
